import { useEffect, useState } from 'react'
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate'
import ClaimLoader from './ClaimLoader'
import ViewClaim from './ViewClaim'

const ActionClaim = ({ claimId, policy, initialClaim }) => {
  const axios = useAxiosPrivate()
  const [claim, setClaim] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    const load = async () => {
      try {
        if (!policy?.policy_id) throw new Error('Missing policy')
        const { data } = await axios.get(
          `/v1/staff-hub/claims/current/${policy.policy_id}/${claimId}?api_token=${process.env.REACT_APP_KIS_TOKEN}`
        )
        if (!data?.claim) throw new Error('Missing claim')
        if (active) {
          setClaim({ ...initialClaim, ...data.claim })
        }
      } catch {
        if (active) setError('Unable to load this claim. Please reload the page to try again.')
      }
    }
    load()
    return () => { active = false }
  }, [claimId, policy?.policy_id])

  if (error) return <p role="alert" className="p-6 text-red-600">{error}</p>
  if (!claim) return <ClaimLoader />
  return <div className="p-6"><ViewClaim claim={claim} policy={policy} /></div>
}

export default ActionClaim
